exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\n\nselect.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\n\nlabel.font-size-17{\n\tfont-size: 17px;\n}\ninput\n{\n\tz-index: auto !important;\n}\n\n.overflow-table{\n\theight: 300px;\n\toverflow-y: auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/shree_translogic_dashboard/src/app/invoice/invoice.component.css
// module id = ../../../../../src/app/invoice/invoice.component.css
// module chunks = main